import React from 'react';
import { motion } from 'framer-motion';
import { CTARow } from './CTARow';
export function AfterYouCallSection() {
  const steps = [{
    step: 'Step 1',
    title: 'Call Jessica',
    description: 'Call Jessica at 623-300-0708 and see how she handles a real customer-style call.'
  }, {
    step: 'Step 2',
    title: 'Book Strategy Call',
    description: 'At the end of the conversation, Jessica books a live Strategy Call with Kevin from Viridia Analytics.'
  }, {
    step: 'Step 3',
    title: 'Customization',
    description: 'On that Strategy Call, Kevin customizes the AI receptionist for your business and maps out next steps.'
  }];
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-15">
            What Happens After You Call Jessica.
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-16">
          {steps.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-17">
              <span className="inline-block px-3 py-1 bg-viridia-100 text-viridia-700 text-sm font-bold rounded-full mb-4" data-id="element-18">
                {item.step}
              </span>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-19">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-20">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-21">
          <p className="text-gray-600 mb-8 italic" data-id="element-22">
            "No pressure and no long-term contracts. If Jessica cannot
            realistically make you more than $697/month in recovered revenue and
            time saved, you should not move forward."
          </p>
          <CTARow align="center" data-id="element-23" />
        </motion.div>
      </div>
    </section>;
}